import { FaCaretRight } from "react-icons/fa";

export const aboutMainItemMobile = [
    {
        id: 1,
        title: "Company",
        companyData: [
            {
                id: 1,
                image: "/assets/Header/About/Company/Our-company",
                href: "/about/our-company",
                title: "Our company",
            },
            {
                id: 2,
                image: "/assets/Header/About/Company/how-we-work",
                href: "/about/how-we-work",
                title: "How we work",
            },
            {
                id: 3,
                image: "/assets/Header/About/Company/csr",
                href: "/about/corporate-social-responsibility",
                title: "CSR",
            },
            {
                id: 4,
                image: "/assets/Header/About/Company/awards",
                href: "/awards",
                title: "Awards",
            },
            {
                id: 5,
                image: "/assets/Header/About/Company/core-team",
                href: "/about/core-team",
                title: "Core team",
            },
            // {
            //     id: 5,
            //     image: "/assets/Header/About/Company/agile-development",
            //     href: "/agile-software-development-company",
            //     title: "Agile development",
            // },
            {
                id: 6,
                image: "/assets/Header/About/Company/career",
                href: "/about/career",
                title: "Career",
            },
            {
                id: 7,
                image: "/assets/Header/About/Company/Client-Testimonials",
                href: "/client-testimonials",
                title: "Client Testimonials",
            },
            {
                id: 8,
                image: "/assets/Header/About/Company/aca",
                href: "/dapp-store",
                title: "Dapp Store",
            },
            // {
            //     id: 8,
            //     image: "/assets/Header/Common/full-cycle-product-development",
            //     href: "/full-cycle-product-development-company",
            //     title: "Full cycle product development",
            //     service: [
            //         {
            //             id: 1,
            //             image: <FaCaretRight />,
            //             href: "/product-management ",
            //             title: "Product management",
            //         },
            //         {
            //             id: 2,
            //             image: <FaCaretRight />,
            //             href: "/mvp-development-company",
            //             title: "MVP Development Company",
            //         },
            //         {
            //             id: 3,
            //             image: <FaCaretRight />,
            //             href: "/startup-app-development-company",
            //             title: "Startups App Development Company",
            //         },
            //         {
            //             id: 4,
            //             image: <FaCaretRight />,
            //             href: "/enterprise-software-development-company",
            //             title: "Enterprise Software Development Company",
            //         },
            //     ],
            // },
        ],
    },

    {
        id: 2,
        title: "Project Costing",
        projectCosting: [
            {
                id: 1,
                image: "/assets/Header/About/Project Costing/Proof-of-Concept",
                href: "/pricing/proof-of-concept",
                title: "Proof of Concept (PoC)",
            },
            {
                id: 2,
                image: "/assets/Header/About/Project Costing/System-Audit",
                href: "/pricing/system-audit",
                title: "System Audit",
            },
            {
                id: 3,
                image: "/assets/Header/About/Project Costing/Software-Maintenance",
                href: "/pricing/software-maintenance",
                title: "Software Maintenance",
            },
            {
                id: 4,
                image: "/assets/Header/About/Project Costing/Product-Discovery",
                href: "/pricing/product-discovery",
                title: "Product Discovery",
            },
            {
                id: 5,
                image: "/assets/Header/About/Project Costing/IT-Consulting",
                href: "/pricing/it-consulting",
                title: "IT Consulting",
            },
            {
                id: 6,
                image: "/assets/Header/About/Project Costing/Dedicated Development Resources",
                href: "/pricing/dedicated-development-resources",
                title: "Dedicated Development Resources",
            },
        ],
    },
    {
        id: 3,
        title: "Dedicated resources",
        dedicatedResources: [
            {
                id: 1,
                image: "/assets/Header/About/Dedicated resources/Hire Blockchain Developers",
                href: "/hire/blockchain-developers",
                title: "Hire Blockchain Developers",
            },
            {
                id: 2,
                image: "/assets/Header/About/Dedicated resources/Hire ReactJS Developers",
                href: "/hire/react-js-developers",
                title: "Hire ReactJS Developers",
            },
            {
                id: 3,
                image: "/assets/Header/About/Dedicated resources/Hire React Native Developers",
                href: "/hire/react-native-developers",
                title: "Hire React Native Developers",
            },
            {
                id: 4,
                image: "/assets/Header/About/Dedicated resources/Hire Next JS Developers",
                href: "/hire/next-js-developers",
                title: "Hire Next JS Developers",
            },
            {
                id: 5,
                image: "/assets/Header/About/Dedicated resources/Hire Tailwind CSS Developers",
                href: "/hire/tailwind-css-developers",
                title: "Hire Tailwind CSS Developers",
            },
            {
                id: 6,
                image: "/assets/Header/About/Dedicated resources/Hire Nuxt JS Developers",
                href: "/hire/nuxt-js-developers",
                title: "Hire Nuxt JS Developers",
            },
            {
                id: 7,
                image: "/assets/Header/About/Dedicated resources/Hire Full Stack Blockchain Developers",
                href: "/hire/bern-full-stack-developers",
                title: "Hire Bern Full Stack Blockchain Developers",
            },
            {
                id: 8,
                image: "/assets/Header/About/Dedicated resources/Hire C language Developers",
                href: "/hire/c-programming-developers",
                title: "Hire C Programming language Developers",
            },
            {
                id: 9,
                image: "/assets/Header/About/Dedicated resources/Hire PHP Developers",
                href: "/hire/php-developers",
                title: "Hire PHP Developers",
            },
            {
                id: 10,
                image: "/assets/Header/About/Dedicated resources/Hire DeFi Developers",
                href: "/hire/defi-developers",
                title: "Hire DeFi Developers",
            },
            {
                id: 11,
                image: "/assets/Header/About/Dedicated resources/Hire Xamarin Dedicated Developer",
                href: "/hire/xamarin-developers",
                title: "Hire xamarin Developer",
            },
            {
                id: 12,
                image: "/assets/Header/About/Dedicated resources/Hire Vue Developer",
                href: "/hire/vue-js-developers",
                title: "Hire Vue Developer",
            },
            {
                id: 13,
                image: "/assets/Header/About/Dedicated resources/Hire Angular JS Developers",
                href: "/hire/angular-js-developers",
                title: "Hire Angular JS Developers",
            },
            {
                id: 14,
                image: "/assets/Header/About/Dedicated resources/Hire Node JS Developers",
                href: "/hire/node-js-developers",
                title: "Hire Node JS Developers",
            },
            {
                id: 15,
                image: "/assets/Header/About/Dedicated resources/Hire Flutter Developers",
                href: "/hire/flutter-developers",
                title: "Hire Flutter Developers",
            },
            {
                id: 16,
                image: "/assets/Header/About/Dedicated resources/Hire Rust Developers",
                href: "/hire/rust-developers",
                title: "Hire Rust Developers",
            },
            {
                id: 17,
                image: "/assets/Header/About/Dedicated resources/Hire Golang Developers",
                href: "/hire/golang-developers",
                title: "Hire Golang Developers",
            },
            {
                id: 18,
                image: "/assets/Header/About/Dedicated resources/Hire Solidity Developers",
                href: "/hire/solidity-developers",
                title: "Hire Solidity Developers",
            },
            {
                id: 19,
                image: "/assets/Header/About/Dedicated resources/Hire Python Dev Developers",
                href: "/hire/python-developers",
                title: "Hire Python Dev Developers",
            },
            {
                id: 20,
                image: "/assets/Header/About/Dedicated resources/Hire C_plus_plus Developers",
                href: "/hire/c-plus-plus-developers",
                title: "Hire C++ Developers",
            },
            {
                id: 21,
                image: "/assets/Header/About/Dedicated resources/Hire Java Developers",
                href: "/hire/java-developers",
                title: "Hire Java Developers",
            },
            {
                id: 22,
                image: "/assets/Header/About/Dedicated resources/Hire Liveops Developer",
                href: "/hire/liveops-developers",
                title: "Hire Liveops Developer",
            },
            {
                id: 23,
                image: "/assets/Header/About/Dedicated resources/Hire Typescript Developer",
                href: "/hire/typescript-developers",
                title: "Hire Typescript Developer",
            },
            {
                id: 24,
                image: "/assets/Header/About/Dedicated resources/Hire CakePHP Developer",
                href: "/hire/cakephp-developers",
                title: "Hire CakePHP Developer",
            },
            {
                id: 25,
                image: "/assets/Header/About/Dedicated resources/Hire Abstraction Developers",
                href: "/hire/abstraction-developers",
                title: "Hire Abstraction Developers",
            },
            {
                id: 26,
                image: "/assets/Header/About/Dedicated resources/Hire DevOps Developers",
                href: "/hire/devops-developers",
                title: "Hire DevOps Developers",
            },
            {
                id: 27,
                image: "/assets/Header/About/Dedicated resources/Hire Etheream Developers",
                href: "/hire/ethereum-developers",
                title: "Hire Ethereum Developers",
            },
            {
                id: 28,
                image: "/assets/Header/About/Dedicated resources/Hire Solana Developers",
                href: "/hire/solana-developers",
                title: "Hire Solana Developers",
            },
            {
                id: 29,
                image: "/assets/Header/About/Dedicated resources/Hire Javascript Developers",
                href: "/hire/javascript-developers",
                title: "Hire Javascript Developers",
            },
            {
                id: 30,
                image: "/assets/Header/About/Dedicated resources/Hire MERN Stack Developers",
                href: "/hire/mern-stack-developers",
                title: "Hire MERN Stack Developers",
            },
            {
                id: 31,
                image: "/assets/Header/About/Dedicated resources/Hire Nest JS Developers",
                href: "/hire/nest-js-developers",
                title: "Hire Nest JS Developers",
            },
            {
                id: 32,
                image: "/assets/Header/About/Dedicated resources/Hire Laravel Developers",
                href: "/hire/laravel-developers",
                title: "Hire Laravel Developers",
            },
            {
                id: 33,
                image: "/assets/Header/About/Dedicated resources/Hire UI UX Designers",
                href: "/hire/ui-ux-designers",
                title: "Hire UI UX Designers",
            },
            {
                id: 34,
                image: "/assets/Header/About/Dedicated resources/Hire Ionic Dedicated Developer",
                href: "/hire/ionic-developers",
                title: "Hire Ionic Developer",
            },
            {
                id: 35,
                image: "/assets/Header/About/Dedicated resources/Hire Codeigniter Developer",
                href: "/hire/codeigniter-developers",
                title: "Hire Codeigniter Developer",
            },
        ],
    },
    // {
    //   id: 4,
    //   title: "City we work in",
    //   cityWeWorkIn: [
    //     {
    //       id: 1,
    //       image: "/assets/Header/About/City work/New York",
    //       href: "/",
    //       title: "New York",
    //     },
    //     {
    //       id: 2,
    //       image: "/assets/Header/About/City work/Paris",
    //       href: "/",
    //       title: "Paris",
    //     },
    //     {
    //       id: 3,
    //       image: "/assets/Header/About/City work/Beijing",
    //       href: "/",
    //       title: "Beijing",
    //     },
    //     {
    //       id: 4,
    //       image: "/assets/Header/About/City work/Mexico City",
    //       href: "/",
    //       title: "Mexico City",
    //     },
    //     {
    //       id: 5,
    //       image: "/assets/Header/About/City work/São Paulo",
    //       href: "/",
    //       title: "São Paulo",
    //     },
    //     {
    //       id: 6,
    //       image: "/assets/Header/About/City work/Hong Kong",
    //       href: "/",
    //       title: "Hong Kong",
    //     },
    //     {
    //       id: 7,
    //       image: "/assets/Header/About/City work/Vienna",
    //       href: "/",
    //       title: "Vienna",
    //     },
    //     {
    //       id: 8,
    //       image: "/assets/Header/About/City work/Dubai",
    //       href: "/",
    //       title: "Dubai",
    //     },
    //     {
    //       id: 9,
    //       image: "/assets/Header/About/City work/Prague",
    //       href: "/",
    //       title: "Prague",
    //     },
    //     {
    //       id: 10,
    //       image: "/assets/Header/About/City work/Toronto",
    //       href: "/",
    //       title: "Toronto",
    //     },
    //     {
    //       id: 11,
    //       image: "/assets/Header/About/City work/Osaka",
    //       href: "/",
    //       title: "Osaka",
    //     },
    //     {
    //       id: 12,
    //       image: "/assets/Header/About/City work/London",
    //       href: "/",
    //       title: "London",
    //     },
    //     {
    //       id: 13,
    //       image: "/assets/Header/About/City work/Guangzhou",
    //       href: "/",
    //       title: "Guangzhou",
    //     },
    //     {
    //       id: 14,
    //       image: "/assets/Header/About/City work/Lisbon",
    //       href: "/",
    //       title: "Lisbon",
    //     },
    //     {
    //       id: 15,
    //       image: "/assets/Header/About/City work/Hangzhou",
    //       href: "/",
    //       title: "Hangzhou",
    //     },
    //     {
    //       id: 16,
    //       image: "/assets/Header/About/City work/Tokyo",
    //       href: "/",
    //       title: "Tokyo",
    //     },
    //     {
    //       id: 17,
    //       image: "/assets/Header/About/City work/Amsterdam",
    //       href: "/",
    //       title: "Amsterdam",
    //     },
    //     {
    //       id: 18,
    //       image: "/assets/Header/About/City work/Sydney",
    //       href: "/",
    //       title: "Sydney",
    //     },
    //     {
    //       id: 19,
    //       image: "/assets/Header/About/City work/Dhaka",
    //       href: "/",
    //       title: "Dhaka",
    //     },
    //     {
    //       id: 20,
    //       image: "/assets/Header/About/City work/Barcelona",
    //       href: "/",
    //       title: "Barcelona",
    //     },
    //     {
    //       id: 21,
    //       image: "/assets/Header/About/City work/Istanbul",
    //       href: "/",
    //       title: "Istanbul",
    //     },
    //     {
    //       id: 22,
    //       image: "/assets/Header/About/City work/Madrid",
    //       href: "/",
    //       title: "Madrid",
    //     },
    //     {
    //       id: 23,
    //       image: "/assets/Header/About/City work/Cape Town",
    //       href: "/",
    //       title: "Cape Town",
    //     },
    //     {
    //       id: 24,
    //       image: "/assets/Header/About/City work/Seoul",
    //       href: "/",
    //       title: "Seoul",
    //     },
    //     {
    //       id: 25,
    //       image: "/assets/Header/About/City work/Chicago",
    //       href: "/",
    //       title: "Chicago",
    //     },
    //     {
    //       id: 26,
    //       image: "/assets/Header/About/City work/Los Angeles",
    //       href: "/",
    //       title: "Los Angeles",
    //     },
    //     {
    //       id: 27,
    //       image: "/assets/Header/About/City work/Rio de Janeiro",
    //       href: "/",
    //       title: "Rio de Janeiro",
    //     },
    //   ],
    // },
];
